/** Field names for the reset-password form. */
export const RESET_PASSWORD_FIELDS = {
  CODE: 'code',
  NEW_PASSWORD: 'newPassword',
  PASSWORD_CONFIRMATION: 'passwordConfirmation'
} as const;

/** Server-side field names returned in the reset-password 400 validation payload. */
export const RESET_PASSWORD_SERVER_FIELDS = {
  EMAIL: 'email',
  CODE: 'code',
  NEW_PASSWORD: 'newPassword',
  PASSWORD_CONFIRMATION: 'passwordConfirmation'
} as const;

/** Validation error codes returned by the reset-password API. */
export const RESET_PASSWORD_VALIDATION_ERROR_CODES = {
  REQUIRED: 'REQUIRED',
  INVALID_LENGTH: 'INVALID_LENGTH',
  INVALID_CHARACTERS: 'INVALID_CHARACTERS',
  PASSWORDS_DO_NOT_MATCH: 'PASSWORDS_DO_NOT_MATCH',
  INVALID_CODE: 'INVALID_CODE',
  MAX_ATTEMPTS_REACHED: 'MAX_ATTEMPTS_REACHED',
  SAME_AS_CURRENT_PASSWORD: 'SAME_AS_CURRENT_PASSWORD'
} as const;

/** RHF error `type` discriminator used to flag max attempts reached (drives the "request a new code" link). */
export const RESET_PASSWORD_ERROR_TYPE = {
  MAX_ATTEMPTS_REACHED: 'maxAttemptsReached'
} as const;

/** Number of alphanumeric chars in a single reset-code group (XXXX). */
export const RESET_CODE_GROUP_LENGTH = 4;

/** Number of groups in a reset code (XXXX-XXXX-XXXX). */
export const RESET_CODE_GROUP_COUNT = 3;

/** Total alphanumeric chars in the reset code, excluding dashes. */
export const RESET_CODE_LENGTH = RESET_CODE_GROUP_LENGTH * RESET_CODE_GROUP_COUNT;

/** Total reset-code length including the two dash separators. */
export const FORMATTED_RESET_CODE_LENGTH = RESET_CODE_LENGTH + (RESET_CODE_GROUP_COUNT - 1);

/** Allowed reset-code format: four Base32 groups separated by dashes (A-Z plus 2-7; 0/1/8/9 excluded by BE). */
export const RESET_CODE_PATTERN = /^[A-Za-z2-7]{4}-[A-Za-z2-7]{4}-[A-Za-z2-7]{4}$/;

/** Sentry feature tag for the reset-password flow. */
export const RESET_PASSWORD_FEATURE_TAG = 'reset-password' as const;

/** Tracking configuration for the reset-password form. */
export const RESET_PASSWORD_FORM_TRACKING_CONFIG = {
  eventPrefix: 'reset_password',
  eventCategory: 'reset_password',
  eventLabel: 'password'
} as const;
